import * as types from "./types";
import {
  getToken,
  isTokenFromLocalStorageValid,
  loginUser,
} from "@/auth/auth.service";

export async function loginUserAction({ commit }, payload) {
  const { data } = await loginUser(payload);
  commit(types.LOGIN_USER, data);
}

export async function useLocalStorageTokenToSignInAction({ commit }) {
  const valid = await isTokenFromLocalStorageValid();
  if (!valid) {
    return;
  }

  const token = getToken();
  commit(types.LOCAL_STORAGE_TOKEN_LOGIN, token);
}
